import ApiCard from "@/api/ApiCard";
import ApiEnter from "@/api/ApiEnter";
import ApiHome from "@/api/ApiHome";
import ApiLinkSupport from "@/api/ApiLinkSupport";
import { ELoginStep } from "@/struct/ELogin/ELoginStep";
import { ICard, IComission } from "@/struct/IHomePage/ICabinetBalance";
import { ILinkSupport } from "@/struct/ILinkSupport/ILinkSupport";
import { IAppInfo, IStoreState, IUserData } from "@/struct/IStore/IStore";
import { Capacitor } from "@capacitor/core";
import { createStore } from "vuex";

export default createStore({
  state: {
        currentCommission: null,
    appName: null,
    appInfo: null,
    yandexClientId: null,
    platform: Capacitor.getPlatform(),
    currentAppVersion: "1.6.2",
    connectionState: true,
    userData: null,
    linkSupport: null,
    userCards: undefined,
    deferredPrompt: null,
    currentLoginStep: ELoginStep.EnterPhone,
    isNeedRegistration: false,
    loginPhone: "",
    loginPassword: "",
  },
  getters: {
      getCurrentCommission(state: IStoreState): IComission | null {
      return state.currentCommission;
    },
    appName(state: IStoreState) {
      return state.appName;
    },
    yandexClientId(state: IStoreState) {
      return state.yandexClientId;
    },
    validateUserPlatform(state: IStoreState) {
      if (state.platform === "web") {
        if (window.matchMedia("(display-mode: standalone)").matches) {
          return "Fstore";
        } else {
          return "Web";
        }
      } else if (state.platform === "android") {
        return "Android";
      } else if (state.platform === "ios") {
        return "IOS";
      } else {
        return false;
      }
    },

    getConnectionState(state: IStoreState): boolean {
      return state.connectionState;
    },
    getUserData(state: IStoreState): IUserData | null {
      return state.userData;
    },
    getAppInfo(state: IStoreState): IAppInfo | null {
      return state.appInfo;
    },
    getLinkSupport(state: IStoreState): ILinkSupport | null {
      return state.linkSupport;
    },
    getUserCards(state: IStoreState): ICard[] | undefined {
      return state.userCards;
    },
    getDeferredPromo(state: IStoreState): any {
      return state.deferredPrompt;
    },
    getCurrentLoginStep(state: IStoreState): ELoginStep {
      return state.currentLoginStep;
    },
    getLoginPhone(state: IStoreState): string {
      return state.loginPhone;
    },
    getLoginPassword(state: IStoreState): string {
      return state.loginPassword;
    },
    getIsNeedRegistration(state: IStoreState): boolean {
      return state.isNeedRegistration;
    },
  },
  mutations: {
      setCurrentCommission(state: IStoreState, commission: IComission | null) {
      state.currentCommission = commission;
    },
    changeConnectionState(state: IStoreState, value: boolean): void {
      state.connectionState = value;
    },
    setUserData(state: IStoreState, data: IUserData): void {
      state.userData = data;
    },
    setAppInfo(state: IStoreState, data: IAppInfo): void {
      state.appInfo = data;
      state.appName = data.app_name;
      state.yandexClientId = data.yandex_client_id;
    },
    setLinkSupport(state: IStoreState, data: ILinkSupport): void {
      state.linkSupport = data;
    },
    setUserCards(state: IStoreState, data: ICard[]): void {
      state.userCards = data;
    },
    setDeferredPrompt(state: IStoreState, data: any) {
      state.deferredPrompt = data;
    },
    setCurrentStep(state: IStoreState, data: ELoginStep) {
      state.currentLoginStep = data;
    },
    setLoginPhone(state: IStoreState, value: string) {
      state.loginPhone = value;
    },
    setLoginPassword(state: IStoreState, value: string) {
      state.loginPassword = value;
    },
    setIsNeedRegistration(state: IStoreState, value: boolean) {
      state.isNeedRegistration = value;
    },
  },
  actions: {
        async fetchCommission({ commit }, commissionId: string) {
      if (!commissionId) {
        commit("setCurrentCommission", null);
        return;
      }
      try {
        const response = await ApiHome.getComission(commissionId);
        commit("setCurrentCommission", response);
      } catch (error) {
        console.error("Failed to fetch commission:", error);
        commit("setCurrentCommission", null);
      }
    },

    async getAppInfo(context) {
      const response = await ApiEnter.getAppInfo();
      if (typeof response != "boolean") context.commit("setAppInfo", response);
    },

    async getUserData(context) {
      const response = await ApiEnter.getAccountUser();
      if (typeof response != "boolean") context.commit("setUserData", response);
    },

    async getLinkSupport(context) {
      const response = await ApiLinkSupport.getLinkSupport();
      if (typeof response != "boolean")
        context.commit("setLinkSupport", response);
    },

    async fetchUserCards(context) {
      const response = await ApiCard.getCards();
      context.commit("setUserCards", response);
    },
    async logout(context) {
      context.commit("setUserData", null);
      context.commit("setUserCards", undefined);
    },
  },
  modules: {},
});
